// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"styles_placeholder__327AN","header":"styles_header__v_FN0","logo":"styles_logo__2479P"};